const removeNthUrlSegment = (url, length) => {
  return url
    .split('/')
    .slice(0, -length)
    .join('/');
};

export default removeNthUrlSegment;
